module.exports = __webpack_public_path__ + "img/viña.60039f88.jpg";